export enum OrderPermission {
    view_orders,
    create_orders,
    delete_orders,
    create_draft_orders,
    view_order_hours,
    create_order_hours,
    delete_order_hours,
    view_order_installations,
    create_order_installations,
    delete_order_installations,
    view_order_materials,
    create_order_materials,
    delete_order_materials,
    view_order_description_settings,
    view_order_descriptions,
    create_order_descriptions,
    delete_order_descriptions,
    view_order_checklists,
    create_order_checklists,
    delete_order_checklists,
    view_order_documents,
    create_order_documents,
    view_order_participants,
    view_order_contacts,
    create_order_contacts,
    delete_order_contacts,
    view_order_properties,
    create_order_properties,
    delete_order_properties,
    view_orderevents,
    view_ordereventdefinitions,
    view_orderevent_actions,
    view_ordereventactiondefinitions,
    view_purchaseorders,
    create_purchaseorders,
    delete_purchaseorders,
    view_purchaseorder_materials,
    create_purchaseorder_materials,
    delete_purchaseorder_materials,
    view_workorders,
    view_orders_status
}

export enum IdentityPermission {
    view_identities = 0,
    create_identities = 1,
    delete_identities = 2,
    view_identity_customers = 3,
    create_identity_customers = 4,
    delete_identity_customers = 5,
    view_identity_installations = 6,
    create_identity_installations = 7,
    delete_identity_installations = 8
}

export enum QuotePermission {
    view_quotes = 8,
    approve_quote = 0,
    reject_quote = 1
}

export enum InvoicePermission {
    view_invoices = 0,
    view_invoice_attachments = 1,
    view_workorder_type_invoices = 2
}

export enum DiscrepancyPermission {
    view_discrepancy = 0,
    view_discrepancy_documents = 1,
}

export enum ActivitySettingsPermission {
    view_activity_permissions = 0,
    update_activity_permissions = 1
}

export enum InstallationStatus {
    New = 0,
    Installed = 1,
    Paused = 2,
    Historical = 3
}

export enum QuoteStatus {
    QUOTE = 0, //Not listed in Connect
    APPROVED = 1,
    REJECTED = 2,
    SENT = 3
}

export enum QuoteOrderType {
    WorkOrder = 0,
    InstallationOrder = 10,
    RepairOrder = 11
}

export enum CategoryType {
    ReasonOfQuoteRejection = 23,
    DiscrepancyType = 14
}

export enum OrderType {
    ServiceOrder = 1,
    RepairOrder = 2,
    WorkOrder = 3,
    InstallationOrder = 4,
    InvoiceOrder = 5,
}

export enum OrderTypeEnumToInvoices {
    All = 99,
    RepairOrder = 11,
    ServiceOrder = 12,
    WorkOrder = 0,
    // PickOrder = 1,
    // CountingOrder = 2,
    // ProjectPickingOrder = 3,
    // ProductionPickingOrder = 4,
    InstallationOrder = 10,
    // InvoiceOrder = 13,
    // CountingOrder2 = 20,
    // TransferOrder = 21,
    // PurchaseReceiptOrder = 22
}

export enum OrderInvoiceStatus {
    All = 99,
    // NotInvoiced = 0,
    PartiallyInvoiced = 1,
    FullyInvoiced = 2
}

export enum DateTypeEnum {
    DueDate = 1,
    InvoiceDate = 2
}

export enum PricingType {
    Fixed = 0,
    FixedFromGroupings = 1,
    RunningCost = 2
}

export enum OrderChecklistPermission {
    view_checklists_on_approved_orders = 0,
    view_checklists_on_partially_approved_orders = 1,
    view_checklists_on_preapproved_orders = 2,
    view_checklists_on_approved_and_highlighted_orders = 3,
    view_checklists_on_unapproved_orders = 4,
    view_checklists_on_completed_orders = 5
}

export enum CreateOrderPermission {
    create_work_orders = 0,
    create_repair_orders = 1, //equipment
    create_free_orders = 2,
    create_customer_specified_date_orders = 3
}

export enum CreateRepairOrderPermission {
    create_repair_orders_for_site = 0,
    create_repair_orders_for_equipment_with_contract = 1
}

export enum InstallationPermission {
    view_installations = 0,
    create_installations = 1,
    view_installation_contacts = 2,
    create_installation_contacts = 3,
    view_installation_equipments = 4
}

export enum ContractPermission {
    view_contracts = 0
}

export enum SmallTalkPermission {
    show_messages = 0,
    view_identity_customers = 1 // necessary for chat GetConversation call to HM API identities controller
}

export enum AccountPermission {
    view_userpermissions = 0,
    view_accounts = 1,
    create_accounts = 2
}

export enum DateRequestPermission {
    date_request_can_set_date_only = 0,
    date_request_show_startby_and_endby_datepicker = 1,
    date_request_can_choose_saturday = 2,
    date_request_can_choose_sunday = 3,
    date_request_can_choose_holiday = 4
}

export enum CreateOrderRequiredFieldSetting {
    create_orders_required_input_customerreference = 0,
    create_orders_required_input_mainorder = 1,
    create_orders_required_input_requisition = 2
}

export enum CreateOrderVisibleFieldSetting {
    create_orders_visible_input_customerreference = 0,
    create_orders_visible_input_mainorder = 1,
    create_orders_visible_input_requisition = 2
}

export enum ViewOrderDescriptionSetting {
    view_descriptions_latest = 0,
    view_descriptions_first_three = 1
}

export enum FilterType {
    order,
    site,
    serviceUnit
}

export enum DeleteErrorResult {
    HasRelatedEntity = 0
}

export enum CreateErrorResult {
    AlreadyExists = 0,
    AlreadyExistsButBelongToADifferentCompany = 1,
    GuestUserInCompany = 2,
    HasLowerPermissionLevel = 3
}

export enum ActivityPermission {
    view_activity_permissions = 0,
    update_activity_permissions = 1
}

export enum SubContext {
    Order = 0,
    Contact = 1,
    Document = 2,
    Description = 3,
    ServiceForm = 4,
    ServiceTask = 5,
    Note = 6,
    Quote = 7,
    Checklist = 8,
    Discrepancy = 9,
    DiscrepancyComment = 10,
    DiscrepancyDocument = 11,
    Participant = 13
}

export enum ActionType {
    New = 0,
    Change = 1,
    Delete = 2,
    Lifecycle = 3
}

export enum ActionParameter {
    //Lifecycle related
    NotDraft = 0,
    PlannedStartDate = 1,
    PlannedFinishDate = 2,
    Started = 3,
    Finished = 4,
    Sent = 5,
    Accepted = 6,
    Rejected = 7,
    Planned = 8,
    Assigned = 9,
    // Changed related
    Category = 10,
    Discrepancy = 11,
    Priority = 12,
    ExtraOrderCategory1 = 13,
    ExtraOrderCategory2 = 14,
    Event = 15,
    Invoicing = 16,
    AssignedToOrder = 17,
    AssignedToQuote = 18,
    RequestedClose = 19,
    Closed = 20,
    CancelCloseRequest = 21,
    AssignedToNextService = 22,
    Reset = 23,
    Classification = 24,
    Severity = 25,
    Type = 26
}

export enum PermissionErrorResult {
    HasLowerPermissionLevel = 0
}

export enum DiscrepancyStatus {
    New = 0,
    RequestAction = 1,
    RequestQuote = 2,
    Closed = 3,
    NextService = 4,
}

export enum DiscrepancyListContext {
    Main = 0,
    Quote = 1,
    Order = 2,
    Asset = 3
}

export enum PieChartContext {
    Order = 0,
    Discrepancy = 1
}

export enum DiscrepancyAction {
    RequestClose = 0,
    CancelClose = 1,
    RequestAction = 2,
    RequestQuote = 3
}

export enum AssetListContext {
    Main = 0,
    Order = 1
}

export enum DiscrepancyActionType {
    RequestClose = 0,
    CancelClose = 1,
    RequestAction = 2,
    RequestQuote = 3
}

export enum OrderStatus {
    New = 1,
    NewPcClient,
    KL_TA_NySp,
    KL_TA_NySpAvsl,
    KL_TA_nTAUendr,
    KL_TA_nTAEndr,
    KL_TA_nTAEndrAvsl,
    KL_TA_nEMUendr,
    KL_TA_nEMEndr,
    KL_TA_nEMEndrAvsl,
    ActiveWithoutOrderNo,
    ActiveWithOrderNo,
    Finished,
    Passive,
    Paused
}

export enum ModuleType {
    Chat
}

export enum AuthMethod {
    AzureB2C = 'AzureB2C',
    IDM = 'IDM'
}